import { render, staticRenderFns } from "./PriceEdit.vue?vue&type=template&id=d2f52ff0&"
import script from "./PriceEdit.vue?vue&type=script&lang=js&"
export * from "./PriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports